import { create } from 'zustand';

const useNavbarStore = create((set) => ({
  isOpen: false,
  toggleOffcanvas: () => set((state) => ({ isOpen: !state.isOpen })),
}));

export default useNavbarStore;